import { brands } from 'Constants';
import { isArray } from 'lodash';

const visualNames = {
  ConditionSupport: 'Condition Support',
  Maternity: 'Maternity',
  BehavioralHealth: 'Behavioral Health',
  WholeHealthConnections: 'Whole Health Connections',
  QualityCareOptions: 'Quality Care Options',
  WorkPlaceExtras: 'Workplace Extras'
};

export { visualNames };

export default state => {
  if (
    !state.planExtras ||
    !state.planExtras.resource ||
    !isArray(state.planExtras.resource)
  ) {
    state.extraMenu = [];
    return;
  }
  const allResources = state.planExtras.resource;
  const unquieSubSections = Array.from(
    new Set(allResources.map(x => x.subsection))
  );
  const allExtra= unquieSubSections.map(x => {
    return {
      code: x,
      name: visualNames[x]
    };
  });
  state.extraMenu =allExtra.filter(x => x.name != undefined);
  console.log("TEST",state.extraMenu);
};
